// useMap — guarded access to the map context (US-874 · R-5).
import { useContext } from "react";
import { MapContext } from "../contexts/MapContext";

const useMap = () => {
  const ctx = useContext(MapContext);
  if (ctx === null) {
    throw new Error("useMap must be used within a <MapProvider>.");
  }
  return ctx;
};

export default useMap;
